@if(sponsors?.length > 0){
    <div class="p-4 relative">
        <div class="top-0 left-0 rounded-md p-4 text-normal w-fit" style="background-color: rgba(0, 0, 0, 0.4)">
            {{'todays_stream_sponsors' | translate}}
        </div>
        <div class="grid grid-flow-col-dense grid-cols-12 gap-6 mt-4">
            @for(sponsor of sponsors; track $index){
                <img [src]="sponsor" class="w-full" alt="sponsored">
            }
        </div>
    </div>
}

